"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAT_MODELS = exports.LLMVendor = exports.getInternalAIModel = exports.LLM_RAG = exports.LLM_FORM_FILL = exports.LLM_DEFAULT = exports.LLM_TMS = exports.LLM_NOTES_COMPONENT_SCANNING = exports.LLM_SANITY_CHECK_BANNING_ORDERS = exports.LLM_PROCESS_HR_ALERT_CROSS_CHECK = exports.LLM_PROCESS_HR_NOTE_ANALYSIS = exports.LLM_PROCESS_BOX = exports.LLMBaseModelThreads = exports.LLMBaseModelT = void 0;
const t = __importStar(require("@sinclair/typebox"));
const tBoxValue = __importStar(require("@sinclair/typebox/value"));
exports.LLMBaseModelT = t.Union([
    t.Literal('gpt-5'),
    t.Literal('gpt-5-mini'),
    t.Literal('gpt-5-nano'),
    t.Literal('claude-sonnet-4'),
    t.Literal('gemini-2.5-pro'),
    t.Literal('gemini-2.5-flash'),
]);
exports.LLMBaseModelThreads = {
    'gpt-5-nano': 64,
    'gpt-5-mini': 64,
    'gpt-5': 32,
    'claude-sonnet-4': 16,
    'gemini-2.5-pro': 24,
    'gemini-2.5-flash': 64,
};
exports.LLM_PROCESS_BOX = {
    baseModel: 'gpt-5',
    reasoning: 'high',
};
exports.LLM_PROCESS_HR_NOTE_ANALYSIS = {
    baseModel: 'gpt-5',
    reasoning: 'medium',
};
exports.LLM_PROCESS_HR_ALERT_CROSS_CHECK = {
    baseModel: 'gpt-5-mini',
    reasoning: 'medium',
};
exports.LLM_SANITY_CHECK_BANNING_ORDERS = {
    baseModel: 'gpt-5-mini',
    reasoning: 'medium',
};
exports.LLM_NOTES_COMPONENT_SCANNING = {
    baseModel: 'gpt-5-mini',
    reasoning: 'medium',
};
exports.LLM_TMS = {
    summarise: { baseModel: 'gpt-5', reasoning: 'high' },
    splitEmailBase: { baseModel: 'gpt-5-mini', reasoning: 'low' },
    splitEmailRetry: { baseModel: 'gpt-5', reasoning: 'high' },
    splitEmailCompare: { baseModel: 'gpt-5-mini', reasoning: 'low' },
    buddy: { baseModel: 'gpt-5', reasoning: 'low' },
};
exports.LLM_DEFAULT = 'gpt-5-mini';
exports.LLM_FORM_FILL = 'gpt-5-mini';
exports.LLM_RAG = {
    rephrase: { baseModel: 'gpt-5', reasoning: 'low' },
    fast: { baseModel: 'gpt-5-mini', reasoning: 'low' },
    good: { baseModel: 'gpt-5', reasoning: 'medium' },
    deep: { baseModel: 'gpt-5', reasoning: 'high' },
};
const getInternalAIModel = (base) => {
    const model = base ?? exports.LLM_DEFAULT;
    if (!tBoxValue.Check(exports.LLMBaseModelT, model)) {
        throw new Error(`Invalid model: ${String(model)}`);
    }
    let key = 'gpt-5-mini-2025-08-07';
    if (model === 'gpt-5') {
        key = 'gpt-5-2025-08-07';
    }
    if (model === 'gpt-5-mini') {
        key = 'gpt-5-mini-2025-08-07';
    }
    if (model === 'claude-sonnet-4') {
        key = 'claude-sonnet-4-20250514';
    }
    if (model === 'gemini-2.5-pro') {
        key = 'gemini-2.5-pro';
    }
    if (model === 'gemini-2.5-flash') {
        key = 'gemini-2.5-flash';
    }
    return exports.CHAT_MODELS[key];
};
exports.getInternalAIModel = getInternalAIModel;
var LLMVendor;
(function (LLMVendor) {
    LLMVendor["OpenAI"] = "openai";
    LLMVendor["Anthropic"] = "anthropic";
    LLMVendor["Gemini"] = "google";
})(LLMVendor || (exports.LLMVendor = LLMVendor = {}));
exports.CHAT_MODELS = {
    'gpt-5-2025-08-07': {
        name: 'gpt-5-2025-08-07',
        maxTokens: 1_000_000,
        costRead: 2,
        costWrite: 8,
        vendor: LLMVendor.OpenAI,
        reasoning: true,
    },
    'gpt-5-mini-2025-08-07': {
        name: 'gpt-5-mini-2025-08-07',
        maxTokens: 1_000_000,
        costRead: 0.4,
        costWrite: 1.6,
        vendor: LLMVendor.OpenAI,
        reasoning: true,
    },
    'gpt-5-nano-2025-08-07': {
        name: 'gpt-5-nano-2025-08-07',
        maxTokens: 1_000_000,
        costRead: 0.1,
        costWrite: 0.4,
        vendor: LLMVendor.OpenAI,
        reasoning: true,
    },
    'claude-sonnet-4-20250514': {
        name: 'claude-sonnet-4-20250514',
        maxTokens: 200_000,
        costRead: 3.0,
        costWrite: 15.0,
        vendor: LLMVendor.Anthropic,
        reasoning: true,
    },
    'gemini-2.5-pro': {
        name: 'gemini-2.5-pro',
        maxTokens: 200_000,
        costRead: 1.25,
        costWrite: 10,
        vendor: LLMVendor.Gemini,
        reasoning: true,
    },
    'gemini-2.5-flash': {
        name: 'gemini-2.5-flash',
        maxTokens: 200_000,
        costRead: 0.15,
        costWrite: 3.5,
        vendor: LLMVendor.Gemini,
        reasoning: true,
    },
};
exports.CHAT_MODELS;
//# sourceMappingURL=types-llm.js.map